<template>
    <div>
        <div class="clearfix row py-2 mb-2 border-bottom">
			<div class="col-sm-12 px-3 company-form-box-title">
				Tax Reducers Approval Settings
			</div>
		</div>
        <div class="row px-3">
			<form enctype="multipart/form-data" @submit.stop.prevent="formSubmit" style="width: 100%;">
                <fieldset :disabled="disabled_by_acl">
                    <div id="settings">
                        <div class="clearfix rounded">
                            <div class="clearfix row no-margin">
                                <div class="col-md-6 float-left fixed-section-one pl-0 mb-4">
                                    <div class="clearfix company-form-container h-100">
                                        <div class="col-sm-12">
                                            <template v-for="(value, key, index) in company_access_settings">
                                                <div :key="index">
                                                    <div class="col-sm-6 pl-0 mb-2 text-secondary font-medium mt-5" style="font-size: 18px;">
                                                        {{stringView(key)}}
                                                    </div>

                                                    <div class="toggle_button_tax">
                                                        <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                                                            <label class="vue-js-switch" :class="{toggled: company_access_settings[key] === true}">
                                                                <input type="radio" v-model="company_access_settings[key]" class="v-switch-input trz_tax_radio" :name="'atl_'+key" :value="true" :disabled="isAccessDisabled()">
                                                                <div class="v-switch-core" :style="{width: '50px', height: '22px', backgroundColor: company_access_settings[key] === true ? '#38c172' : '#e3342f', borderRadius: '11px'}">
                                                                    <div class="v-switch-button"></div>
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <div class="col-sm-5 trz_tax_button">Enabled</div>
                                                    </div>

                                                    <div class="toggle_button_tax mb-5">
                                                        <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                                                            <label class="vue-js-switch" :class="{toggled: company_access_settings[key] === false}">
                                                                <input type="radio" v-model="company_access_settings[key]" class="v-switch-input trz_tax_radio" :name="'atl_'+key" :value="false" :disabled="isAccessDisabled()">
                                                                <div class="v-switch-core" :style="{width: '50px', height: '22px', backgroundColor: company_access_settings[key] === false ? '#38c172' : '#e3342f', borderRadius: '11px'}">
                                                                    <div class="v-switch-button"></div>
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <div class="col-sm-5 trz_tax_button">Disabled</div>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <template v-if="!disabled_by_acl">
                                <b-button type="submit"  variant="success" class="float-right mt-3">
                                    Save
                                </b-button>
                            </template>
                        </div>
                    </div>
                </fieldset>
			</form>
		</div>
    </div>
</template>
<script>
    export default{

        mounted() {

        },
        props: ['pageurl'],
        components: {
        },
        data(){

            return {
                company_access_settings :{},
                disabled_by_acl : false,

            }
        },
        methods:{
            stringView(str)
            {
                if(str == 'jobposition')
                    str = 'job_position';
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },

            isAccessDisabled()
            {
                return this.disabled_by_acl;
            },

            get_access_settings: function()
            {
                //
                if(!this.checkNet()) return false;
                axios.get(this.pageurl+'/company/tax-reducers-settings' , {
                }).then(function(response){

                    let company_access_settings_temp = {};
                    company_access_settings_temp = response.data;

                    for (const [key, value] of Object.entries(company_access_settings_temp)) {

                            if(value==1)
                            {
                                company_access_settings_temp[key] = true;
                            }
                            else
                            {
                                company_access_settings_temp[key] = false;
                            }

                            }

                    this.company_access_settings = company_access_settings_temp;

                }.bind(this));
            },

            formSubmit(e)
            {
                e.preventDefault();

                var text = JSON.stringify(this.company_access_settings);
                let formData = new FormData();
                formData.append('tax_reducers_settings', text);

                // formData.append('company_id', this.company_id);
                this.component_data = [];
                let currentObj = this;

                axios.post(this.pageurl + '/company/tax-reducers-settings/save', formData)
                    .then(function (response)
                    {
                        this.$bvToast.toast(response.data.message, {title: 'Success',variant: 'success',solid: true});

                    }.bind(this))
                    .catch(function (error)
                    {
                        this.$bvToast.toast(error.response.data.errors.toString(), {title: 'Error!',variant: 'danger',solid: true});
                    });

            },

        },
        created: function(){
            this.get_access_settings();
        },
        computed:
        {

        }
    }
</script>